import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Clock, Calendar } from 'lucide-react';
import { WeeklyScheduleManager } from './WeeklyScheduleManager';
import { ExceptionsManager } from './ExceptionsManager';
import { AvailabilityCalendar } from './AvailabilityCalendar';
interface TeacherAvailabilityManagerProps {
  teacherCode: string;
}
export function TeacherAvailabilityManager({
  teacherCode
}: TeacherAvailabilityManagerProps) {
  return <div className="space-y-6">
      
      
      {/* ภาพรวม */}
      <div>
        <AvailabilityCalendar teacherCode={teacherCode} />
      </div>

      {/* แยก tabs สำหรับการจัดการ */}
      <div>
        <Tabs defaultValue="weekly" className="w-full">
          <TabsList className="grid w-full max-w-2xl grid-cols-2">
            <TabsTrigger value="weekly" className="flex items-center gap-2">
              <Clock size={16} />
              <span>ช่วงเวลารับงานสอน</span>
            </TabsTrigger>
            <TabsTrigger value="exceptions" className="flex items-center gap-2">
              <Calendar size={16} />
              <span>วัน/เวลา หยุดการสอน (ชั่วคราว)</span>
            </TabsTrigger>
          </TabsList>
          
          <div className="mt-6">
            <TabsContent value="weekly">
              <WeeklyScheduleManager teacherCode={teacherCode} />
            </TabsContent>
            <TabsContent value="exceptions">
              <ExceptionsManager teacherCode={teacherCode} />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>;
}